<div class="checkin-component" *ngIf="readyForPickUp()">
  <hmf-alert-banner
    messageType="info"
    messageTitle="Curbside & In Store Pickup"
    messageBody="<ul style='padding-left:15px'><li>Go to the pickup area</li><li>Tap 'Check In Online' below.</li><li>Enter your vehicle or clothing description</li></ul>"
  />
  <div class="row">
    <div class="col-12 checkin-button-container">
      <hmf-button
        [variant]="'secondary'"
        [text]="'Check in online'"
        (click)="submitCheckIn()"
        data-testid="curbside-submit-button">
      </hmf-button>
    </div>
  </div>
</div>
